import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';

@Component({
  selector: 'app-multi-schema-type',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormlyMaterialModule, FormlyModule, HttpClientModule],
  templateUrl: './multi-schema-type.component.html',
  styleUrl: './multi-schema-type.component.scss'
})
export class MultiSchemaTypeComponent extends FieldType {

}
